import React, { Component, PropsWithChildren } from 'react';
import ErrorPage from '../../pages/_error';

const SKIP_RENDERING_ERROR_BOUNDARY_IF_DEV = false;

class ErrorBoundary extends Component<
	PropsWithChildren<unknown>,
	{ hasError: boolean; error: any }
> {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: undefined };
	}

	static getDerivedStateFromError() {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		// You can also log the error to an error reporting service

		this.setState({
			error: `${error}: ${JSON.stringify(errorInfo)}`,
		});

		console.error('Error caught by ErrorBoundary:');
		console.error(error);
		console.error(errorInfo);
	}

	render() {
		const skipBecauseLocal =
			SKIP_RENDERING_ERROR_BOUNDARY_IF_DEV && process.env.NEXT_PUBLIC_ISLOCAL;

		if (this.state.hasError && !skipBecauseLocal) {
			// Fallback UI if an error occurs
			return <ErrorPage error={this.state.error} />;
		}

		return <React.Fragment>{this.props.children}</React.Fragment>;
	}
}

export default ErrorBoundary;
